export default class PersistenceError extends Error {
    constructor(err) {
        super("Error persisting object: " + err);
    }
}
